import { defineComponent, computed, h } from 'vue';

const recursiveRender = (nodes) => {
    if (!nodes)
        return;
    return nodes.map(node => h(node.tag, node.att, recursiveRender(node.nds)));
};
var script = defineComponent({
    name: 'SSRIcon',
    props: {
        class: {
            type: String,
            default: ''
        },
        viewBox: {
            type: String,
            default: '0 0 24 24'
        },
        colour: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: ''
        },
        modifier: {
            type: String,
            default: ''
        },
        prefix: {
            type: String,
            default: ''
        },
        paths: {
            type: Array,
            default: () => []
        },
        ariaHidden: {
            type: Boolean,
            default: true
        }
    },
    setup(props, { attrs }) {
        const classes = computed(() => {
            const baseClass = `${props.prefix}svg-icon`;
            return ({
                [`${baseClass}`]: true,
                [`${props.class}`]: props.class,
                [`${baseClass}--${props.colour}`]: props.colour,
                [`${baseClass}--${props.size}`]: props.size,
                [`${baseClass}--${props.modifier}`]: props.modifier
            });
        });
        return { classes };
    },
    render() {
        return h('svg', {
            'aria-hidden': this.ariaHidden,
            focusable: false,
            viewBox: this.viewBox,
            class: this.classes
        }, recursiveRender(this.paths));
    }
});

script.__file = "packages/vue/ssr-icon/lib/SSRIcon.vue";

export { script as default };
